const CURRENT_BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION;

let versionCheck: Promise<void> | null = null;
let reloadStarted = false;
let versionCheckStarted = false;

export const reloadIfNewBuildIsAvailable = (): Promise<void> => {
  if (!CURRENT_BUILD_VERSION || process.env.NODE_ENV !== 'production' || reloadStarted || versionCheckStarted) {
    return Promise.resolve();
  }

  if (versionCheck) {
    return versionCheck;
  }

  versionCheckStarted = true;
  versionCheck = fetch(`/version.json?t=${Date.now()}`, {
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-cache',
    },
  })
    .then((response) => (response.ok ? response.json() : null))
    .then((manifest) => {
      const deployedVersion = manifest?.version;

      if (deployedVersion && deployedVersion !== CURRENT_BUILD_VERSION) {
        reloadStarted = true;
        window.location.reload();
      }
    })
    .catch(() => {
      // A version-check failure must never block a successful API request.
    })
    .finally(() => {
      versionCheck = null;
    });

  return versionCheck;
};
